export default "__VITE_ASSET__CHDV6Zds__"